const css = `.checkbox-group {
  display: flex;
  gap: 12px;
}
.checkbox-group.checkbox-group-vertical {
  flex-direction: column;
}
.checkbox-group.checkbox-group-horizontal {
  flex-direction: row;
  flex-wrap: wrap;
}
.checkbox-group.checkbox-group-disabled {
  opacity: 0.6;
}
.checkbox-group .checkbox-group-item {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 24px;
}
.checkbox-group .checkbox-group-item.checkbox-group-select-all {
  padding-bottom: 8px;
  border-bottom: 1px solid var(--surface-border);
}
.checkbox-group .checkbox-group-item.checkbox-group-select-all .checkbox-select-all-label {
  font-weight: var(--font-weight-semibold);
  color: var(--accent);
}
.checkbox-group .checkbox-group-item.checkbox-group-select-all .checkbox-select-all-label:hover {
  color: var(--accent-hover);
}
.checkbox-group .checkbox-group-item.checkbox-group-select-all .checkbox-select-all-label.disabled {
  color: var(--text-color-secondary);
}
.checkbox-group .checkbox-group-item.checkbox-group-select-all .checkbox-select-all-label.disabled:hover {
  color: var(--text-color-secondary);
}
.checkbox-group .checkbox-group-item .checkbox-label {
  font-size: var(--font-size-sm);
  color: var(--text-color);
  cursor: pointer;
  user-select: none;
  transition: color 0.2s ease;
}
.checkbox-group .checkbox-group-item .checkbox-label:hover {
  color: var(--primary-color);
}
.checkbox-group .checkbox-group-item .checkbox-label.disabled {
  color: var(--text-color-secondary);
  cursor: not-allowed;
}
.checkbox-group .checkbox-group-item .checkbox-label.disabled:hover {
  color: var(--text-color-secondary);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
